<template>
  <div class="container-fluid page">
      
    <div class="row">
      <div class="col-lg-4 mt-4">
        <branch-status-card :isRetailer="false" v-if="availabilityPeriods && thisCharity" :location="thisCharity" @dropsCancelled="updateData()" :availabilityPeriods="availabilityPeriods"></branch-status-card>
      </div>

      <div class="col-lg-8 mt-4">
        <drop-status-card thisLocationType="charity" :usePagination="true" :resultsPerPage="3" :drops="todaysDrops"></drop-status-card>
      </div>
    </div>

    <div class="row flex-grow-1">
      <div class="col-12 mt-4">
        <charity-past-drops-card @updated="updateData()" :usePagination="true" :resultsPerPage="5" :showReportIssueButton="false" :drops="pastDrops"></charity-past-drops-card>
      </div>
    </div>

  </div>
</template>
<script>
  // Imports
  import DropStatusCard from '@/components/Cards/DropStatusCard';
  import CharityPastDropsCard from '@/components/Cards/CharityPastDropsCard';
  import BranchStatusCard from '@/components/Cards/BranchStatusCard';
  import DropsService from '../../../services/DropsService';
  import CharitiesService from '../../../services/CharitiesService';
  import UserStore from '../../../services/UserStore';
  //
  export default {
    name: 'charity-dashboard',

    components: {
      DropStatusCard,
      CharityPastDropsCard,
      BranchStatusCard
    },

    data() {
      return {
        thisCharity: null,
        todaysDrops: [],
        pastDrops: [],
        availabilityPeriods: []
      };
    },
    
    created() {
      this.getavailabilityPeriods();
      this.updateData();
    },

    methods:{

      async getavailabilityPeriods(){
        try{
          let result = await CharitiesService.getAvailabilityPeriods(UserStore.userData.groupEntityId);
          this.availabilityPeriods = result.data;
        } catch (error){
          console.log(error)
        }
      },

      updateData() {
        // No need to update availabilityPeriods
        this.updateTodaysDrops();
        this.updatePastDrops();
        this.updateCharity();
      },

      async updateCharity() {
        try{
          let result = await CharitiesService.getById(UserStore.userData.groupEntityId);
          this.thisCharity = result.data;
        } catch (error){
          console.log(error)
        }
      },

      async updateTodaysDrops() {
        try{
          let result = await DropsService.getMine('upcoming');
          this.todaysDrops = result.data;
        } catch (error){
          console.log(error)
        }
      },

      async updatePastDrops() {
        try{
          let result = await DropsService.getMine('past');
          this.pastDrops = result.data;
        } catch (error){
          console.log(error)
        }
      },
    }
  };
</script>
<style>
    .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 8rem);
  }
</style>
